import React from 'react'
import HiringHeroSection from '../components/HiringSection/HiringHeroSection'
import HiringCtA from '../components/HiringSection/HiringCtA'

const Hiring = () => {
  return (
    <div>
        <HiringHeroSection/>
        {/* <HiringCtA/> */}
    </div>
  )
}

export default Hiring